/* eslint-disable prettier/prettier */
/* 신청서 store */
import { getElaApplInfo, getApplLine, postApplApproval } from '@/api/ela';
import { getFileList } from '@/api/file';
import elaApplicationStore from './elaApplicationStore';
import elaViewerStore from './elaViewerStore';

const elaStore = {
  namespaced: 'ELA',

  state: {
    // ======================= 조회조건 =======================
    adminYn: '',
    authPg: '',
    searchApplSeq: '', // 조회 신청서순번
    searchApplCd: '', // 조회 신청서코드
    searchApplStatusCd: '', // 조회 신청서상태코드
    searchApplSabun: '', // 조회 신청자사번
    searchApplInSabun: '', // 조회 신청입력자사번
    searchApplYmd: '', // 조회 신청일자 (미사용)
    etc01: '', // 근태코드
    etc02: '', // 근태코드
    etc03: '', // 근태코드
    etc04: '', // 근태코드
    etc05: '', // 근태코드

    // ======================= 조회결과 =======================
    applSeqExist: '', // 신청서상태구분 (신규신청 : N 결재,임시저장 : Y)
    applStatusCd: '', // (결재/임시저장일때) 신청서상태코드
    orgLvl: '', //  결재선레벨값
    cancelBtnVisible: '', // 회수버튼유무
    agreeSeq: '', // (현재 결재차례의) 결재순번

    userInfo: {}, // 신청자정보(151)
    uiInfo: {}, // 신청서화면정보(101)
    levelCodeList: [], // 결재레벨코드목록

    // 결재정보 - A. 현재 신규건일때
    applLine: [], // 결재자정보
    referLine: [], // 참조자정보
    mgrLine: [], // 담당자정보

    // 결재정보 - B. 현재 결재/임시저장건일때
    thri103: {}, // 결재마스터
    thri107: [], // 결재내역
    thri125: [], // 수신참조

    // ================= 신청저장 결재정보(A+B) =================
    applUserList: [], // 결재자리스트
    referUserList: [], // 참조자리스트
    mgrUserList: [], // 참조자리스트
    // ================= 추가 신청 정보 =================
    fileId: '',
    fileList: [],
    idx: 0,
  },

  getters: {
    GET_ELA_APPL_PARAM(state) {
      // 신청시 사용하는 파라미터
      return {
        searchApplCd: state.searchApplCd,
        searchApplSabun: state.searchApplSabun,
        searchApplInSabun: state.searchApplInSabun,
        searchApplSeq: state.searchApplSeq,
        searchApplYmd: state.searchApplYmd,
        applStatusCd: state.applStatusCd || '21',
      };
    },
    GET_ELA_APPL_SAVE_PARAM(state) {
      // 신청서 결재,반려 저장시 사용하는 파라미터
      return {
        searchApplSabun: state.searchApplSabun,
        searchApplSeq: state.searchApplSeq,
        searchApplCd: state.searchApplCd,
        agreeSeq: state.agreeSeq,
        applSeq: state.searchApplSeq,
        agreeUserMemo: '', // 결재,반려사유
      };
    },
    GET_SEARCH_APPL_CD(state) {
      return state.searchApplCd;
    },
    GET_SEARCH_APPL_SEQ(state) {
      return state.searchApplSeq;
    },
    GET_FILE_ID(state) {
      return state.fileId;
    },
    GET_FILE_LIST(state) {
      return state.fileList;
    },
    GET_REFER_USER_LIST(state) {
      return state.referUserList;
    },
    GET_UI_INFO(state) {
      return state.uiInfo;
    },
    GET_APPL_USER_LIST(state) {
      return state.applUserList;
    },
    GET_ORG_LEVEL(state) {
      return state.orgLvl;
    },
    GET_LEVEL_CODE_LIST(state) {
      return state.levelCodeList;
    },
    GET_APPL_SEQ_EXIST(state) {
      return state.applSeqExist;
    },
    GET_MGR_USER_LIST(state) {
      return state.mgrUserList;
    },
  },

  mutations: {
    /* 신청서 초기 - 데이터 세팅 */
    SET_ELA_INIT_DATA(state, data) {
      state.userInfo = data.userInfo;
      state.uiInfo = data.uiInfo;
      state.levelCodeList = data.levelCodeList;
      state.applLine = data.applLine;
      state.referLine = data.referLine;
      state.mgrLine = data.mgrLine;
      state.thri103 = data.thri103;
      state.thri107 = data.thri107;
      state.thri125 = data.thri125;

      state.adminYn = data.adminYn;
      state.applSeqExist = data.applSeqExist;
      state.applStatusCd = data.applStatusCd;
      state.authPg = data.authPg;
      state.cancelBtnVisible = data.cancelBtnVisible;
      state.etc01 = data.etc01;
      state.etc02 = data.etc02;
      state.etc03 = data.etc03;
      state.etc04 = data.etc04;
      state.etc05 = data.etc05;
      state.orgLvl = data.orgLvl;
      state.searchApplCd = data.searchApplCd;
      state.searchApplInSabun = data.searchApplInSabun;
      state.searchApplSabun = data.searchApplSabun;
      state.searchApplSeq = data.searchApplSeq;

      state.applUserList = []; // 초기화 후 세팅
      state.referUserList = [];
      state.mgrUserList = [];
      state.applUserList = data.applUserList;
      state.referUserList = data.referUserList;
      state.mgrUserList = data.mgrUserList;
    },

    /* 결재레벨 변경시 - 결재자,참조자 데이터 세팅 */
    SET_APPL_LEVEL_CHANGE_DATA(state, data) {
      // 1. 결재자 세팅
      if (state.uiInfo.agreeYn == 'Y') {
        state.applUserList = []; // state 초기화

        let applTransitionInfo = [];
        const applLineList = data.applLine;

        applLineList.forEach(item => {
          applTransitionInfo.push({
            applTypeCd: item.applTypeCd,
            applTypeCdNm: item.applTypeCdNm,
            org: item.agreeOrgNm == null ? '' : item.agreeOrgNm,
            jikchak: item.agreeJikchakNm == null ? '' : item.agreeJikchakNm,
            jikwee: item.agreeJikweeNm == null ? '' : item.agreeJikweeNm,
            agreeEmpAlias: item.agreeEmpAlias,
            agreeName: item.agreeName,
            agreeSabun: item.agreeSabun,
            agreeSeq: item.agreeSeq,
            gubun: item.applTypeCd == '30' ? '0' : '1', // !!! 재확인필요 !!!
          });
        });

        state.applUserList = applTransitionInfo;
      }
      // 2. 참조자 세팅
      // elaFooter 706번째 줄 참고
      state.referUserList = []; // state 초기화

      /*
      let referTransitionInfo = [];
      const referLineList = data.referLine;

      referLineList.forEach(item => {
        referTransitionInfo.push({
          agreeSeq: item.agreeSeq,
          referSabun: item.ccSabun,
          referOrg: item.ccOrgNm,
          referJikchak: item.ccJikchakNm,
          referJikwee: item.ccJikWeeNm,
          inSabun: item.inSabun,
          inOrg: item.inOrgNm,
          inJikchak: item.inJikchakNm,
          inJikwee: item.inJikweeNm,
          name: item.name,
        });
      });

      state.referUserList = referTransitionInfo;
      */

      //담당자 셋팅
      state.mgrUserList = [];
      let mgrTransitionInfo = [];
      const mgrLineList = data.mgrLine;
      mgrLineList.forEach(item => {
        mgrTransitionInfo.push({
          agreeSeq: data.applLine.length + data.mgrLine.length,
          mgrSabun: item.sabun,
          mgrJikwee: item.jikweeNm == null ? '' : item.jikweeNm,
          mgrJikweeNm: item.jikweeNm == null ? '' : item.jikweeNm,
          mgrJikchak: item.jikchakNm == null ? '' : item.jikchakNm,
          mgrJikchakNm: item.jikchakNm == null ? '' : item.jikchakNm,
          mgrOrgNm: item.orgNm == null ? '' : item.orgNm,
          name: item.name,
          inSabun: item.inSabun,
          inOrg: item.inOrgNm == null ? '' : item.inOrgNm,
          inJikchak: item.jikchakNm == null ? '' : item.jikchakNm,
          inJikwee: item.jikweeNm == null ? '' : item.jikweeNm,
          applTypeCd: '40',
          gubun: '3',
          orgAppYn: 'N',
        });

      });
      state.mgrUserList = mgrTransitionInfo;
    },

    /* 결재선 변경시 - 결재자 데이터 세팅 */
    SET_APPL_USER_LIST(state, data) {
      state.applUserList = []; // state 초기화
      state.applUserList = data;
    },

    /* 참조자 추가시 - 참조자 데이터 세팅 */
    SET_REFER_USER_LIST(state, data) {
      state.referUserList = []; // state 초기화
      state.referUserList = data;
    },
    /*담당자 추가시 - 담당자 데이터 셋팅*/
    SET_MGR_USER_LIST(state, data) {
      state.mgrUserList = []; // state 초기화
      state.mgrUserList = data;
    },

    /* 결재레벨값 변경 */
    SET_ORG_LVL(state, data) {
      state.orgLvl = data;
    },

    /* 파일 아이디 */
    SET_FILE_ID(state, data) {
      state.fileId = data;
    },

    /* 파일 목록 */
    SET_FILE_LIST(state, data) {
      state.fileList = data;
    },

    /* state 초기화 */
    RESET_ELA_STATE(state) {
      state.adminYn = '';
      state.authPg = '';
      state.searchApplSeq = ''; // 조회 신청서순번
      state.searchApplCd = ''; // 조회 신청서코드
      state.searchApplStatusCd = ''; // 조회 신청서상태코드
      state.searchApplSabun = ''; // 조회 신청자사번
      state.searchApplInSabun = ''; // 조회 신청입력자사번
      state.searchApplYmd = ''; // 조회 신청일자 (미사용)
      state.etc01 = ''; // 근태코드
      state.etc02 = ''; // 근태코드
      state.etc03 = ''; // 근태코드
      state.etc04 = ''; // 근태코드
      state.etc05 = ''; // 근태코드

      // ======================= 조회결과 =======================
      state.applSeqExist = ''; // 신청서상태구분 (신규신청 : N 결재;임시저장 : Y)
      state.applStatusCd = ''; // (결재/임시저장일때) 신청서상태코드
      state.orgLvl = ''; //  결재선레벨값
      state.cancelBtnVisible = ''; // 회수버튼유무
      state.agreeSeq = ''; // (현재 결재차례의) 결재순번

      state.userInfo = {}; // 신청자정보(151)
      state.uiInfo = {}; // 신청서화면정보(101)
      state.levelCodeList = []; // 결재레벨코드목록

      // 결재정보 - A. 현재 신규건일때
      state.applLine = []; // 결재자정보
      state.referLine = []; // 참조자정보
      state.mgrLine = []; // 담당자정보

      // 결재정보 - B. 현재 결재/임시저장건일때
      state.thri103 = {}; // 결재마스터
      state.thri107 = []; // 결재내역
      state.thri125 = []; // 수신참조

      // ================= 신청저장 결재정보(A+B) =================
      state.applUserList = []; // 결재자리스트
      state.referUserList = []; // 참조자리스트
      state.mgrUserList = []; // 참조자리스트
      // ================= 추가 신청 정보 =================
      state.fileId = '';
      state.fileList = [];
    },
  },

  actions: {
    /* 신청서 초기 데이터 */
    async FETCH_ELA_APPL_INFO({ commit }, params) {
      // 0. 초기화
      commit('RESET_ELA_STATE');

      // 1. API 호출 (신청서초기정보조회)
      const response = await getElaApplInfo(params);
      if(!response.data) return;
      const responseData = response.data.data;

      // console.log('FETCH_ELA_APPL_INFO : '+JSON.stringify(responseData));

      // 2. 신청상태에 따라 결재정보(결재자,참조자) 분기 처리
      let applTransitionInfo = [];
      let referTransitionInfo = [];
      let referLineAllList = [];

      let mgrTransitionInfo = []; // 담당자
      let mgrLineAllList = []; //

      // 2-a. '최초'일때
      if (responseData.applSeqExist == 'N') {
        const applLineList = responseData.applLine; // 결재자
        referLineAllList = responseData.referLine; // 참조자
        mgrLineAllList = responseData.mgrLine;

        applLineList.forEach((item, idx) => {
          if (
            (responseData.uiInfo.agreeYn == 'N' &&
              item.agreeSabun == responseData.sessionContext.ssnSabun) ||
            responseData.uiInfo.agreeYn != 'N'
          ) {
            const gubun = item.applTypeCd == '30' ? '0' : '1';
            const seq = idx + 1;
            applTransitionInfo.push({
              applTypeCd: item.applTypeCd,
              applTypeCdNm: item.applTypeCdNm,
              gubun: gubun,
              org: item.agreeOrgNm == null ? '' : item.agreeOrgNm,
              jikchak: item.agreeJikchakNm == null ? '' : item.agreeJikchakNm,
              jikwee: item.agreeJikweeNm == null ? '' : item.agreeJikweeNm,
              agreeEmpAlias: item.agreeEmpAlias,
              agreeName: item.agreeName,
              agreeSabun: item.agreeSabun,
              agreeSeq: seq,
            });
          }
        });

        //담당자 최초  ejkim
        mgrLineAllList.forEach((item, idx) => {
          const seq3 =  applTransitionInfo.length + idx + 1;
          mgrTransitionInfo.push({
            applTypeCd: item.applTypeCd,
            mgrSabun: item.sabun,
            name: item.name,
            mgrOrgNm: item.orgNm,
            mgrJikweeNm: item.jikweeNm == null ? '' : item.jikweeNm,
            mgrJikchakNm: item.jikchakNm == null ? '' : item.jikchakNm,
            agreeSeq: seq3,
            inSabun: item.inSabun,
            inOrg: item.inOrgNm,
            inJikchak: item.inJikchakNm == null ? '' : item.inJikchakNm,
            inJikwee: item.inJikweeNm == null ? '' : item.inJikweeNm,
            gubun: item.gubun,
            orgAppYn: item.orgAppYn
          });
        });

      }

      // 2-b. '임시저장/결재'일때
      if (responseData.applSeqExist == 'Y') {
        const thri107List = responseData.thri107; // 결재자
        referLineAllList = responseData.thri125; // 참조자
        //mgrLineAllList = responseData.thri125; //mgrLine

        thri107List.forEach(item => {
          // 기안(30), 결재(10)만 추출
          if (item.applTypeCd == '30' || item.applTypeCd == '10') {
            const ymd =
              responseData.applStatusCd == '' ||
              responseData.applStatusCd == '11'
                ? ''
                : item.agreeYmd;

            const approvalFlg = ymd != null && ymd != '';

            applTransitionInfo.push({
              applTypeCd: item.applTypeCd,
              applTypeCdNm: item.applTypeCdNm,
              ymd: ymd,
              org: item.agreeOrgNm,
              jikchak: item.agreeJikchakNm,
              jikwee: item.agreeJikweeNm,
              agreeEmpAlias: item.agreeEmpAlias,
              agreeName: item.agreeName,
              agreeSabun: item.agreeSabun,
              agreeSeq: item.agreeSeq,
              approvalFlg: approvalFlg,
              agreeStatusCd: item.agreeStatusCd,
              agreeStatusCdNm: item.agreeStatusCdNm,
              memo: item.memo,
            });

            // 대결이 있으면 추가
            if (
              item.deputyYn == 'Y' ||
              (item.deputyName != '' && item.deputyName != null)
            ) {
              applTransitionInfo.push({
                applTypeCd: item.applTypeCd,
                applTypeCdNm: '대결',
                ymd: item.agreeYmd,
                org: item.deputyOrgNm,
                jikchak: item.deputyJikchakNm,
                jikwee: item.deputyJikweeNm,
                agreeEmpAlias: item.deputyName, // 대결자 alias가 없어서 name으로 대체
                agreeName: item.deputyName,
                agreeSabun: item.deputySabun,
              });
            }
          }
          //40담당만
          if(item.applTypeCd == '40'){
            mgrTransitionInfo.push({
              mgrSabun: item.agreeSabun,
              name: item.agreeName,
              mgrOrgNm: item.agreeOrgNm,
              mgrJikweeNm: item.agreeJikweeNm,
              mgrJikchakNm: item.agreeJikchakNm,
              agreeSeq:item.agreeSeq,
              applTypeCd:item.applTypeCd,
            });
          }
        });

      }

      referLineAllList.forEach(item => {
        referTransitionInfo.push({
          agreeSeq: item.agreeSeq,
          referSabun: item.ccSabun,
          referOrg: item.ccOrgNm,
          referJikchak: item.ccJikchakNm,
          referJikwee: item.ccJikWeeNm,
          inSabun: item.inSabun,
          inOrg: item.inOrgNm,
          inJikchak: item.inJikchakNm,
          inJikwee: item.inJikweeNm,
          name: item.name,
        });
      });
      //조회

      // 3. 최종 responseData 데이터 세팅
      responseData['applUserList'] = applTransitionInfo;
      responseData['referUserList'] = referTransitionInfo;

      responseData['mgrUserList'] = mgrTransitionInfo ;//mgrTransitionInfo;

      // 4. state 세팅
      commit('SET_ELA_INIT_DATA', responseData);
    },

    /* 결재레벨 변경 조회 */
    async FETCH_APPL_LINE({ commit }, params) {
      const response = await getApplLine(params);
      commit('SET_APPL_LEVEL_CHANGE_DATA', response.data.data);
    },

    /* 결재 데이터 저장 */
    async SAVE_APPL_APPROVAL({ state }) {
      const param = {
        searchApplCd: state.searchApplCd,
        applStatusCd: state.applStatusCd !== '' ? state.applStatusCd : '21',
        searchApplName: state.userInfo.name,
        searchApplSeq: state.searchApplSeq,
        searchApplYmd: state.searchApplYmd,
        searchApplSabun: state.searchApplSabun,
        applSeq: state.searchApplSeq,
        procExecYn: state.uiInfo.procExecYn,
        etc01: state.etc01,
        etc02: state.etc02,
        etc03: state.etc03,
        applTitle: state.uiInfo.applTitle,
        searchApplInSabun: state.searchApplInSabun,
        fileSeq: state.fileId,
        pathSeq: state.orgLvl,
        applUserList: state.applUserList,
        referUserList: state.referUserList,
        mgrUserList: state.mgrUserList,
      };
      try {
        return await postApplApproval(param);
      } catch (error) {
        console.log(error);
      }
    },

    /* 파일 목록 조회 */
    async FETCH_FILE_LIST({ state, commit }) {
      if (state.thri103 === null) {
        return false;
      }
      const fileIds = state.thri103.fileSeq;
      if (fileIds === '' || fileIds === null || fileIds === undefined)
        return false;

      const { data } = await getFileList(fileIds);
      if (data.message === 'OK') {
        commit('SET_FILE_LIST', data.fileList[0][fileIds]);
      }
    },
  },
  modules: {
    elaApplicationStore,
    elaViewerStore,
  },
};

export default elaStore;
